module.exports = __webpack_public_path__ + "img/MEDIA003.99af4a6b.jpg";